/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { showModal } from "actions";
import { Trans } from "react-i18next";

class Survey extends Component {
  handleDetailClick = (survey, fullname) => {
    this.renderSurvey(
      fullname.split[0],
      fullname.split[1],
      survey.inviteId,
      survey.surveyIdentifier
    );
  };

  renderSurvey = (FirstName, LastName, InviteId, identifierId) => {
    var se = new window.SurveyEmbed(
      identifierId,
      "https://forms.office.com/",
      "https://mfpembedcdnweu.azureedge.net/mfpembedcontweu/",
      "true"
    );
    let context = {
      "First Name": FirstName,
      "Last Name": LastName,
      InviteId: InviteId,
    };

    se.renderPopup(context);
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  render() {
    const { survey } = this.props;
    return (
      <>
        <tr>
          <td className="showGrup">{survey.survey.name}</td>
          <td className="showGrup">{survey.subject}</td>
          <td className="showGrup">
            <a
              href="#"
              data-toggle="modal"
              data-target="#duyuruModal"
              className="btn btn-fga-view"
              onClick={() =>
                this.handleDetailClick(survey, this.props.fullname)
              }
            >
              <Trans desc="Göster">10143</Trans>{" "}
              <span className="iconmford fo-icon-search" style={{ fontSize: 0 }}></span>
            </a>
          </td>
        </tr>
      </>
    );
  }
}

export default connect(null, { showModal })(Survey);
